/**
 * Combined CRUD + seat handlers — composed from useUserCrudHandlers and useUserSeatHandlers.
 *
 * Extracted from UserManagementPage.tsx (Sub-PR 6.3).
 */

import type { AvailableLicenseForSeat } from '../../services/admin'
import type { User } from '../../types'
import type { CreateUserForm } from './types'
import { useUserCrudHandlers } from './use-user-crud-handlers'
import { useUserSeatHandlers } from './use-user-seat-handlers'

interface HandlerDependencies {
  selectedUser: User | null
  selectedLicense: string
  userToReactivate: User | null
  formData: CreateUserForm
  setFormLoading: (v: boolean) => void
  setFormError: (msg: string | null) => void
  setError: (msg: string | null) => void
  setShowCreateModal: (v: boolean) => void
  setShowEditModal: (v: boolean) => void
  setShowDeleteModal: (v: boolean) => void
  setShowSeatModal: (v: boolean) => void
  setShowReactivateModal: (v: boolean) => void
  setShowResetPasswordModal: (v: boolean) => void
  setIssuedPassword: (v: string | null) => void
  setSelectedUser: (user: User | null) => void
  setSelectedLicense: (id: string) => void
  setUserToReactivate: (user: User | null) => void
  setReactivateLicenses: (lics: AvailableLicenseForSeat[]) => void
  resetForm: () => void
  loadData: () => Promise<void>
}

interface UserHandlers {
  handleCreateUser: (e: React.FormEvent) => Promise<void>
  handleUpdateUser: (e: React.FormEvent) => Promise<void>
  handleDeleteUser: () => Promise<void>
  handleResetPassword: () => Promise<void>
  handleAssignSeat: () => Promise<void>
  handleConfirmReactivate: () => Promise<void>
}

export function useUserHandlers(deps: HandlerDependencies): UserHandlers {
  const crud = useUserCrudHandlers(deps)
  const seat = useUserSeatHandlers(deps)
  return { ...crud, ...seat }
}
